import { FormsEnum, SectionsEnum } from 'app/shared/enums';
// prettier-ignore
import { setHistoryVisibilityBasedOnPersonalData } from 'app/services/businessFunctions/helpers/setHistoryVisibilityBasedOnPersonalData';

const historyVisibilityBasedOnPersonalData = {
  setSecondCoownerHistoryVisibilityBasedOnPersonalData() {
    setHistoryVisibilityBasedOnPersonalData({
      insuranceHistorySection: SectionsEnum.Coowners2InsuranceHistory,
      formName: FormsEnum.CalculationForm,
    });
  },
};

export default historyVisibilityBasedOnPersonalData;
